<template>
  <div class="main-content-container">
    <div class="left-column">
      <img src="@/assets/imgs/404.svg">
    </div>
    <div class="right-column">
      <div class="content">
        <h1>Oops!</h1>
        <h2>{{ message }}</h2>
        <h3>Error code: {{ code }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    message() {
      let { customerName } = this.$route.query
      if (customerName) {
        return `Customer ${customerName} has been deleted.`
      } else if (this.$route?.params?.message) {
        return this.$route.params.message;
      }
      return "We can’t seem to find the page you’re looking for.";
    },
    code() {
      if (this.$route?.params?.code) {
        return this.$route?.params?.code;
      } else {
        return "404";
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
.main-content-container {
  display: flex;
  .left-column, .right-column {
    flex: 1;
  }
  .left-column {
    display: flex;
    justify-content: center;
    align-items: center;
    align-items: flex-end;
    flex-direction: column;
    img {
      margin-right: 20px;
    }
  }
  .right-column {
    align-items: flex-start;
    flex-direction: column;
    display: flex;
    justify-content: center;
    .content {
      h1, h2, h3 {
        padding: 5px;
      }
      h1 {
        font-weight: bold;
        font-size: 48px;
        color: $primary-dark;
      }
      h2 {
        font-size: 24px;
        color: $primary-dark;
      }
      h3 {
        font-size: 18px;
        color: $secondary--text;
      }
    }
  }
}
</style>
